import React, { useCallback, useEffect, useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import api from '../services/api';
import ItemsTab from '../components/general-inventory/ItemsTab';
import ReorderTab from '../components/general-inventory/ReorderTab';
import StocktakeTab from '../components/general-inventory/StocktakeTab';
import ReportsTab from '../components/general-inventory/ReportsTab';
import { typeOf } from '../components/general-inventory/types';
import { getOrgLocale } from '../../lib/locale';

export default function GeneralInventory() {
  const [items, setItems] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [lists, setLists] = useState({ categories: [], locations: [], units: [] });

  const reload = useCallback(() => {
    api.get('/general-inventory/items').then((r) => setItems(r.data || []));
    api.get('/general-inventory/categories').then((r) => setLists(r.data));
  }, []);

  useEffect(() => {
    reload();
    api.get('/suppliers').then((r) => setSuppliers(r.data || [])).catch(() => setSuppliers([]));
  }, [reload]);

  const low = items.filter((i) => i.low_stock).length;
  return (
    <div className="p-4 md:p-8 space-y-4" data-testid="general-inventory-page">
      <div>
        <h1 className="text-3xl font-bold text-slate-900">General Inventory</h1>
        <p className="text-slate-600 mt-1" data-testid="gi-type-blurb">
          <span className="inline-block text-xs font-semibold uppercase tracking-wide bg-slate-900 text-white rounded px-2 py-0.5 mr-2" data-testid="gi-type-badge">{typeOf(getOrgLocale().inventory_type).label}</span>
          {typeOf(getOrgLocale().inventory_type).blurb} <a href="/app/settings" className="text-sky-700 underline text-sm">Change type</a>
        </p>
      </div>
      <Tabs defaultValue="items">
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="items" data-testid="gi-tab-items">Items</TabsTrigger>
          <TabsTrigger value="reorder" data-testid="gi-tab-reorder">Reorder{low ? ` (${low})` : ''}</TabsTrigger>
          <TabsTrigger value="stocktake" data-testid="gi-tab-stocktake">Stocktakes</TabsTrigger>
          <TabsTrigger value="reports" data-testid="gi-tab-reports">Reports</TabsTrigger>
        </TabsList>
        <TabsContent value="items"><ItemsTab items={items} suppliers={suppliers} lists={lists} reload={reload} /></TabsContent>
        <TabsContent value="reorder"><ReorderTab suppliers={suppliers} /></TabsContent>
        <TabsContent value="stocktake"><StocktakeTab lists={lists} reload={reload} /></TabsContent>
        <TabsContent value="reports"><ReportsTab /></TabsContent>
      </Tabs>
    </div>
  );
}
